<template>
  <div :id="uid" class="notification-container">
    <div
      v-if="afficherNotification"
      class="overlay-contenu-connexe"
      :class="[jel_getClassObject(content), content.theme, { active: isActive }]"
      :style="{
        '--largeur': content.typeNotification.largeur + 'px',
        '--hauteur': content.typeNotification.hauteur + 'px',
      }"
      :data-component-gacategory="content.googleAnalytics?.eventCategory"
      :data-component-gaaction="content.googleAnalytics?.eventAction"
      :data-component-galabel="content.googleAnalytics?.eventLabel"
    >
      <span class="btn-close text-center" @click="fermerNotification()">x</span>
      <MediaVideo v-if="content.typeNotification.field == 'video'" :content="contentMediaVideo" />
      <b-link
        v-else-if="content.typeNotification.field == 'image'"
        class="d-flex justify-content-center align-items-center"
        :class="{ 'img-only': content.typeNotification.notes }"
        v-bind="jel_getLienBinding(content.typeNotification.lien)"
      >
        <div :class="content.typeNotification.notes ? 'w-50 pr-1' : 'w-100'">
          <img
            :ga-img-name="content.typeNotification.image['@name']"
            :src="jel_getFichierSrc(content.typeNotification.image)"
            :alt="content.typeNotification.imageAlt"
            class="w-100"
          />
        </div>
        <div
          v-if="content.typeNotification.notes"
          class="justify-content-center"
          :class="{ 'w-50 pl-1': content.typeNotification.image }"
        >
          <div>
            <strong v-if="content.typeNotification.title">{{
              content.typeNotification.title
            }}</strong>
          </div>
          <div
            v-if="content.typeNotification.notes"
            class="note"
            v-html="content.typeNotification.notes"
          />
        </div>
      </b-link>
    </div>
  </div>
</template>

<script>
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';
import MediaVideo from '@/components/bingo/media/MediaVideo';

export default {
  name: 'Notification',
  components: {
    MediaVideo,
  },
  mixins: [mixinEnvironnement],
  props: { content: { type: Object, required: true } },
  data() {
    return {
      afficherNotification: true,
      isActive: false,
      observer: null,
      offsetHeight: 0,
    };
  },
  computed: {
    contentMediaVideo() {
      return {
        videoLien: this.content.typeNotification.idYoutube,
        autoplay: false,
        bgImage: null,
        hauteur: this.content.typeNotification.hauteur,
        largeur: this.content.typeNotification.largeur,
      };
    },
  },
  created() {
    this.observer = new IntersectionObserver(this.onElementObserved, {
      root: this.$el,
      threshold: 1.0,
    });
  },
  beforeDestroy() {
    this.observer.disconnect();
  },

  mounted() {
    this.$nextTick(() => {
      this.jel_setCookieAffichage(this.content); // nextTick obligatoire
    });
    setTimeout(() => {
      this.observer.observe(this.$el);
      this.offsetHeight = document.getElementById(this.uid).firstChild.offsetHeight;
    }, 1000);
  },
  methods: {
    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting }) => {
        // la 2e partie de la condition nécessaire pour que la notification ne disparaisses pas
        // quand on scroll down plus bas que sa zone d'affichage dans la page
        if (!isIntersecting && window.pageYOffset + this.offsetHeight < target.offsetTop) {
          this.isActive = false;
          return;
        }
        this.isActive = true;
      });
    },
    fermerNotification() {
      this.afficherNotification = false;
      this.jel_setCookieAffichageFermeture(this.content);
    },
  },
};
</script>

<style lang="scss" scoped>
.overlay-contenu-connexe {
  transform: translateX(150%);
  opacity: 0;
  transition: all 0.2s ease-out;
  will-change: transform, opacity;
  transition-property: transform, opacity;
  backface-visibility: hidden;

  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9999;

  width: var(--largeur);
  height: var(--hauteur);

  box-shadow: 0 0 40px rgba(0, 0, 0, 0.3);
  display: block;
  color: white !important;
  min-width: 200px;
  background: #fff;
  padding: 15px;
  margin-bottom: 20px;
  margin-right: 20px;

  @include media-breakpoint-down(sm) {
    margin-bottom: 15px;
    margin-right: 15px;
  }
  &.active {
    transform: translateX(0%);
    opacity: 1;
    cursor: auto;
    @include media-breakpoint-down(sm) {
      &:first-child {
        margin-bottom: 0;
      }
    }
  }

  &.clair {
    background: #fff;
  }
  &.fonce {
    background: #000;
  }
  a {
    text-decoration: none;
  }
}

.btn-close {
  position: absolute;
  border: none;
  right: 0px;
  top: -10px;
  width: 21px;
  height: 21px;
  display: block;
  color: #fff;
  background-color: #555;
  text-decoration: none;
  border-radius: 15px;
  z-index: 1;
  cursor: pointer;
  @include media-breakpoint-up(md) {
    right: -10px;
  }
}

.embed-responsive {
  min-width: 320px;
}

.notification-container {
  height: 1px;
}

::v-deep .iframe_video {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  min-height: 0;
}
</style>
